(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["secasa-mica-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('secasa-mica-picker')) {
  customElements.define('secasa-mica-picker', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.data = JSON.parse(this.querySelector('[data-mica-data]').textContent);
      this.variants = this.data.variants.map(entry => ({...entry.variant, image: entry.image, components: entry.components}));
      this.form = document.getElementById(this.getAttribute('form-id'));
      this.variant = this.variants.find(variant => variant.id === this.data.selected) || this.variants[0];
      this.addEventListener('change', event => {
        const input = event.target.closest('[data-mica-input]');
        if (!input) return;
        const position = Number(input.dataset.micaInput);
        const wanted = [...this.variant.options];
        wanted[position] = input.value;
        const candidates = this.variants.filter(variant => variant.options[0] === wanted[0]);
        const chosen = candidates.find(variant => variant.options.every((value, index) => value === wanted[index]))
          || candidates.find(variant => variant.options[1] === wanted[1] && (position !== 2 || variant.options[2] === wanted[2]))
          || candidates.find(variant => variant.options[position] === wanted[position])
          || candidates[0];
        if (chosen) this.selectVariant(chosen, true);
      });
      this.selectVariant(this.variant, false);
    }
    selectVariant(variant, updateUrl) {
      const previousVariant = this.variant;
      this.variant = variant;
      const body = variant.options[0] === 'Body Only';
      this.querySelectorAll('[data-mica-position]').forEach(group => {
        const position = Number(group.dataset.micaPosition);
        const candidates = this.variants.filter(candidate => position === 0 || (candidate.options[0] === variant.options[0] && (position !== 2 || candidate.options[1] === variant.options[1])));
        const values = [...new Set(candidates.map(candidate => candidate.options[position]))];
        group.hidden = position > 0 && (body || (position === 1 && values.length === 1 && values[0] === 'Standard'));
        group.querySelector('[data-mica-selected]').textContent = variant.options[position];
        group.querySelectorAll('[data-mica-input]').forEach(input => {
          input.checked = input.value === variant.options[position];
          const choice = input.closest('.secasa-mica-choice');
          choice.hidden = input.value === 'Not applicable' || !values.includes(input.value);
          if (group.querySelector('img')) {
            const preview = candidates.find(candidate => candidate.options[position] === input.value && candidate.options.every((value, index) => index === position || value === variant.options[index])) || candidates.find(candidate => candidate.options[position] === input.value);
            const image = choice.querySelector('img');
            if (preview?.image && image) {image.removeAttribute('srcset');image.src = preview.image;image.alt = preview.options.filter(value => value !== 'Not applicable').join(' / ');}
          }
        });
      });
      const idInput = this.querySelector('input[name="id"]');
      idInput.value = variant.id;
      idInput.dataset.sku = variant.sku || '';
      const components = this.querySelector('[data-mica-components]');
      components.disabled = !variant.components;
      components.value = variant.components || '';
      const sectionScope = this.closest('[data-section-type="product"]') || this.parentElement;
      const scope = this.form || this.closest('product-form') || sectionScope;
      const priceList = scope.querySelector('.price-list') || this.parentElement.querySelector('.price-list');
      const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {style:'currency', currency:this.data.currency || 'AUD'}).format(value / 100);
      if (priceList) {
        priceList.replaceChildren();
        const price = document.createElement('span');
        price.className = variant.compare_at_price > variant.price ? 'price price--highlight' : 'price';
        price.setAttribute('aria-label', this.data.labels.sale);
        price.textContent = money(variant.price);
        priceList.append(price);
        if (variant.compare_at_price > variant.price) {
          const compare = document.createElement('span');compare.className='price price--compare';compare.setAttribute('aria-label',this.data.labels.regular);compare.textContent=money(variant.compare_at_price);priceList.append(compare);
        }
      }
      const summary = this.querySelector('[data-mica-summary]');
      summary.textContent = variant.components ? `${this.data.labels.included.replace(/:\s*$/, '')}: ${variant.components}` : `${variant.sku || ''}`;
      scope.querySelectorAll('square-placement[data-amount]').forEach(placement => placement.setAttribute('data-amount', (variant.price / 100).toFixed(2)));
      const sku = sectionScope.querySelector('.product-meta__sku-number');
      if (sku) sku.textContent = variant.sku || '';
      const saving = sectionScope.querySelector('.product-label--on-sale');
      if (saving) {saving.hidden = !(variant.compare_at_price > variant.price);saving.textContent = this.data.labels.discount.replace('__SAVINGS__', this.data.discountMode === 'percentage' ? `${Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price)}%` : money(variant.compare_at_price - variant.price));}
      if (this.form) {
        this.form.querySelectorAll('[data-action="add-to-cart"]').forEach(button => {button.disabled = !variant.available;button.textContent = variant.available ? this.data.labels.add : this.data.labels.sold;});
        idInput.dispatchEvent(new Event('change', {bubbles:true}));
        for (const name of ['variant:change','variant:changed']) this.form.dispatchEvent(new CustomEvent(name,{bubbles:true,detail:{formId:this.form.id,variant,previousVariant}}));
      }
      const mediaId = variant.featured_media?.id;
      if (mediaId && previousVariant?.id !== variant.id) {
        const galleryThumb = sectionScope.querySelector('.product-gallery__thumbnail[data-media-id="' + mediaId + '"]');
        if (galleryThumb) galleryThumb.click();
      }
      if (updateUrl && this.hasAttribute('update-url')) {const url=new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState({},'',url);}
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
